// src/data/affinities.ts — Tabla de afinidades ORIGINAL de Aetheria (no Pokémon)
// Filososfía: cada afinidad representa una forma de vínculo con el cristal de Aetheria.
// Valores: 0.5 débil, 1 neutro, 1.5 bueno, 2 muy bueno, 0.7 leve resistencia, 1.3 leve ventaja

import type { AsteriaElement } from '../entities/asteria.js';

export type AffinityChart = Record<AsteriaElement, Record<AsteriaElement, number>>;

export const AFFINITY_CHART: AffinityChart = {
  // atacante → defensor
  terra: { terra: 1, aqua: 0.7, ignis: 0.7, aero: 1.5, astra: 1, umbra: 1, lumen: 1.3 },
  aqua:  { terra: 1.5, aqua: 1, ignis: 2, aero: 1, astra: 0.7, umbra: 1, lumen: 1 },
  ignis: { terra: 1.5, aqua: 0.5, ignis: 1, aero: 1.3, astra: 1, umbra: 1.3, lumen: 1 },
  aero:  { terra: 0.5, aqua: 1, ignis: 1, aero: 1, astra: 1.5, umbra: 0.7, lumen: 1.3 },
  astra: { terra: 1, aqua: 1.3, ignis: 1, aero: 0.7, astra: 1, umbra: 2, lumen: 0.7 },
  umbra: { terra: 1, aqua: 1, ignis: 0.7, aero: 1.3, astra: 0.5, umbra: 1, lumen: 2 },
  lumen: { terra: 0.7, aqua: 1, ignis: 1, aero: 0.7, astra: 1.5, umbra: 0.5, lumen: 1 },
};

export function affinityMultiplier(attacker: AsteriaElement, defender: AsteriaElement): number {
  return AFFINITY_CHART[attacker]?.[defender] ?? 1;
}

export function affinityLabel(mult:number): string {
  if(mult >= 2) return '¡Muy eficaz!';
  if(mult >= 1.5) return '¡Eficaz!';
  if(mult <= 0.5) return 'Poco eficaz...';
  if(mult < 1) return 'Resistido...';
  return '';
}
